import { stringifyEntityRef, SystemEntity } from "@backstage/catalog-model";
import { DiscoveryApi, FetchApi } from "@backstage/core-plugin-api";

export class FeatureFlagService {

  constructor(
    private readonly fetchApi: FetchApi,
    private readonly discoveryApi: DiscoveryApi,
  ) {}

  public async searchFeatureFlagsBySystem(system: SystemEntity) {
    const baseUrl = await this.discoveryApi.getBaseUrl('feature-flags-manager');
    const url = new URL(`${baseUrl}/feature-flags`);
    url.searchParams.append('system', stringifyEntityRef(system));

    return this.fetchApi.fetch(url)
      .then(response => response.ok ? response.json() : undefined)
  }

  public async getFeatureFlagDetails(flagId: string) {
    const baseUrl = await this.discoveryApi.getBaseUrl('feature-flags-manager');
    const url = new URL(`${baseUrl}/feature-flags/${flagId}`);

    return this.fetchApi.fetch(url)
      .then(response => response.ok ? response.json() : undefined)
  }

  public async searchFeatureFlagsByState(system: SystemEntity, state: 'ACTIVE' | 'INACTIVE') {
    const baseUrl = await this.discoveryApi.getBaseUrl('feature-flags-manager');
    const url = new URL(`${baseUrl}/feature-flags`);
    url.searchParams.append('system', stringifyEntityRef(system));
    url.searchParams.append('state', state);

    return this.fetchApi.fetch(url)
        .then(response => response.ok ? response.json() : undefined)
  }

  public async updateFeatureFlags(flagsData: any) {
    const baseUrl = await this.discoveryApi.getBaseUrl('feature-flags-manager');
    const url = new URL(`${baseUrl}/feature-flags/batch`);

    return this.fetchApi.fetch(url, { 
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(flagsData)
    })
      .then(response => response.ok ? response.json() : undefined)
  }
}